<template>
    <a
        href="#close"
        aria-hidden="true"
        class="uk-modal-close uk-close"
        @click.prevent="$emit('click')"
    ></a>
</template>

<script>
export default {
    name: "DismissLink"
}
</script>
